var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.456,
    height: 93.942,
    viewBox: "0 0 70.456 93.942",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file-upload",
    d: "M41.1,24.953V0H4.4A4.393,4.393,0,0,0,0,4.4V89.538a4.393,4.393,0,0,0,4.4,4.4H66.053a4.393,4.393,0,0,0,4.4-4.4V29.357H45.5A4.416,4.416,0,0,1,41.1,24.953ZM53.059,64.587H41.1V79.265A2.935,2.935,0,0,1,38.164,82.2H32.293a2.935,2.935,0,0,1-2.936-2.936V64.587H17.4a2.936,2.936,0,0,1-2.068-5.02L33.021,42.008a3.128,3.128,0,0,1,4.411,0L55.123,59.567A2.935,2.935,0,0,1,53.059,64.587ZM69.172,19.265,51.209,1.284A4.4,4.4,0,0,0,48.09,0H46.971V23.486H70.457V22.366A4.389,4.389,0,0,0,69.172,19.265Z",
    fill: "#00945e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.013b022c28606d2fbc76ea83e36b54a7.svg";
export { ForwardRef as ReactComponent };